export default __webpack_public_path__ + "static/media/no-sugar.656044e2.png";